import { useContext, useEffect, useState } from 'react';
import '../styles/basic.css';
import '../styles/ass.css';
import { post } from '../api';
import CursorProvider from '../providers/CursorProvider';
import ExecProvider from '../providers/ExecProvider';
import { useNavigate } from 'react-router';

export function Search(props: {}) {
    const [text, setText] = useState<string>('');
    const [search, setSearch] = useState<string>('');
    const [result, setResult] = useState<string>('');
    const cursorProvider = useContext(CursorProvider.context);
    const execProvider = useContext(ExecProvider.context);
    const navigate = useNavigate();

    const handleChange = (event : any) => {
        setText(event.target.value);
    };

    const handleSubmit = (event : any) => {
        if (text != '')
            setSearch(text);
        else
            setResult('');
        event.preventDefault();
    };

    const handleResult = (res : string) => {
        console.log(res);
        const split = res.split(':');
        if (split.length == 2)
        {
            if (split[0] == "cursor")
            {
                cursorProvider.setStateFromCode(split[1]);
                setResult('Help Granted!');
                return;
            }
            else if (split[0] == "exec")
            {
                execProvider.addCommand(split[1]);
                setResult('Help Granted!');
                return;
            }
            else if (split[0] == "redirect")
            {
                navigate(split[1]);
                return;
            }
        }

        cursorProvider.setStateFromCode('');
        setResult(res);
    };

    useEffect(() => {
        if (search == '')
            return;

        try {
            const body = { key: search };

            post('api/search', body)
                .then(res => res.json())
                .then(res => {
                    setSearch('');
                    setText('');    
                    handleResult(res.value);
                });
        } catch (e) {
            console.log(e);
            return;
        }
    }, [search]);

    return (
        <div className='h-box center-all gap-4'>
            <form onSubmit={handleSubmit} className='h-box gap-4 center-all cursor-none'>
                <b>Search</b>
                <input value={text} onChange={handleChange} />
                <input type="submit" value="Submit" className='og-button' />
            </form>
            {search != '' ? <p className='ass-text'>'Searching...'</p> : null}
            {result != '' ? <p className='ass-text'>{result}</p> : null}
        </div>
    );
}